import { IconPicker } from '@assembly-js/design-system';

import { iconPickerClassName } from 'src/components/icons';
import { useSuggestIconAction } from 'src/hooks/useSuggestIconAction';

interface SuggestIconPickerProps {
  value: string;
  onChange: (iconName: string) => void;
  appName: string;
  className?: string;
}

export const SuggestIconPicker = ({
  value = 'dashboard',
  onChange,
  appName,
  className,
}: SuggestIconPickerProps) => {
  const { isSuggesting, renderSuggestAction, suggestingIndicator } =
    useSuggestIconAction({ appName, onChange });

  if (isSuggesting) {
    return suggestingIndicator(className);
  }

  return (
    <IconPicker
      className={className ?? iconPickerClassName}
      value={value}
      onChange={onChange}
      inlineAction={renderSuggestAction}
    />
  );
};
